export default "/images/Frame 7.jpg?6596e00d67bbfc224cff57eef449276c";